import React from 'react';
import { SpView } from 'src/components/SpView';
import { ScrollView, StyleSheet } from 'react-native';
import { SpText } from '../../../../components/SpText/SpText';
import { useTranslation } from 'react-i18next';
import colors from '@styles/colors';
import UnlockSVG from 'src/components/SvgIcons/UnlockSVG';
import LockSVG from 'src/components/SvgIcons/LockSVG';
import IndoorOnlySVG from 'src/components/SvgIcons/IndoorOnlySVG';
import CurfewEnabledSVG from 'src/components/SvgIcons/CurfewEnabledSVG';

const CatFlapActionsControlSlide = () => {
  const { t } = useTranslation();
  return (
    <ScrollView>
      <SpView style={styles.wrapper}>
        <SpView style={styles.itemWrapper}>
          <SpView style={styles.lockUnlockIcons}>
            <LockSVG
              color={colors.greyText.color}
              width={45}
              height={45}
              viewBox="0 0 28 28"
            />
            <UnlockSVG
              color={colors.greyText.color}
              width={45}
              height={45}
              viewBox="0 0 28 28"
            />
          </SpView>
          <SpText style={styles.title}>{t('lock_and_unlock')}</SpText>
          <SpText style={styles.text}>{t('lock_and_unlock_tour_text')}</SpText>
        </SpView>
        <SpView style={styles.itemWrapper}>
          <CurfewEnabledSVG
            color={colors.greyText.color}
            width={45}
            height={45}
            viewBox="0 0 30 30"
          />
          <SpText style={styles.title}>{t('curfews')}</SpText>
          <SpText style={styles.text}>{t('curfews_tour_text')}</SpText>
        </SpView>
        <SpView style={styles.itemWrapper}>
          <IndoorOnlySVG
            color={colors.greyText.color}
            width={40}
            height={40}
            viewBox="0 0 28 28"
          />
          <SpText style={styles.title}>{t('inside_only')}</SpText>
          <SpText style={styles.text}>{t('inside_only_tour_text')}</SpText>
        </SpView>
      </SpView>
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  wrapper: {
    marginTop: 32,
    rowGap: 32,
    flexDirection: 'column',
  },
  itemWrapper: {
    paddingHorizontal: 19,
    columnGap: 7,
    alignItems: 'center',
  },
  title: {
    textAlign: 'center',
    fontSize: 20,
    lineHeight: 28,
    fontFamily: 'Rubik_Medium',
    color: colors.greyText.color,
  },
  text: {
    lineHeight: 20,
    color: colors.greyText.color,
    textAlign: 'center',
    fontSize: 14,
  },
  lockUnlockIcons: {
    flexDirection: 'row',
    marginBottom: 7,
  },
});

export default CatFlapActionsControlSlide;
